import { useLocation } from "wouter";
import { useEffect, useState } from "react";
import { get, patch } from "../common/net/requester";

import { Button, NotificationSettingEdit, PlatformHeader } from "../components";
import { UserNotification } from "../interfaces/User";

const Settings = () => {
    const [, setLocation] = useLocation();
    const [notifications, setNotifications] = useState<UserNotification>(
        {} as UserNotification,
    );
    const [username, setUsername] = useState("");
    const [workingNotifications, setWorkingNotifications] =
        useState<UserNotification>({} as UserNotification);
    const [workingUsername, setWorkingUsername] = useState("");

    useEffect(() => {
        get<{ username: string; notification: UserNotification }>(`/user`)
            .then((res) => {
                if (!res.ok) {
                    console.log(res.status, res.message);
                    return;
                }

                setNotifications(res.body.notification);
                setUsername(res.body.username);

                setWorkingNotifications(res.body.notification);
                setWorkingUsername(res.body.username);
            })
            .catch((err) => {
                console.log("Failed to fetch user profile:", err);
            });
    }, []);

    const updateUserProfile = (
        username: string,
        notification: UserNotification,
    ) => {
        patch(`/user`, {
            username,
            summary: notification.summary,
            quote: notification.quote,
        })
            .then((res) => {
                if (!res.ok) {
                    console.log(res.status, res.message);
                    return;
                }
            })
            .catch((err) => console.log("Failed to update user:", err));
    };

    const signout = () => {
        sessionStorage.clear();
        localStorage.clear();

        setLocation("/");
    };

    return (
        <div className="routeParent">
            <div className="routeInnerCol">
                <PlatformHeader />

                <div style={{ flex: 1, width: "100%", padding: "0 15em" }}>
                    <h2>Profile</h2>
                    <label htmlFor="username">Username</label>
                    <input
                        name="username"
                        style={{
                            width: "100%",
                            textAlign: "center",
                            fontSize: "18px",
                        }}
                        type="text"
                        value={workingUsername}
                        onChange={(e) => setWorkingUsername(e.target.value)}
                    />

                    <h2>Notifications</h2>
                    {workingNotifications.summary && (
                        <NotificationSettingEdit
                            name="Summary"
                            config={workingNotifications.summary}
                            updateConfig={(config) =>
                                setWorkingNotifications((p) => ({
                                    ...p,
                                    summary: config,
                                }))
                            }
                        />
                    )}
                    {workingNotifications.quote && (
                        <NotificationSettingEdit
                            name="Quote"
                            config={workingNotifications.quote}
                            updateConfig={(config) =>
                                setWorkingNotifications((p) => ({
                                    ...p,
                                    quote: config,
                                }))
                            }
                        />
                    )}

                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            gap: "1em",
                            marginTop: "1em",
                        }}
                    >
                        <Button
                            text="Submit"
                            onClick={() =>
                                updateUserProfile(
                                    workingUsername,
                                    workingNotifications,
                                )
                            }
                            disabled={
                                workingUsername === username &&
                                workingNotifications === notifications
                            }
                        />
                        <Button
                            text="Sign out"
                            color="red"
                            variant="outline"
                            onClick={() => signout()}
                        />
                        <Button
                            text="Delete Account"
                            onClick={() => console.log("hey")}
                            background="red"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
